import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "relative",
  action: "#",
  method: "GET"
}
const _hoisted_2 = {
  for: "search-field",
  class: "sr-only"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 py-3 h-full absolute left-1",
  src: "/img/Icons/Magnifying_glass.svg",
  alt: "Search Icon"
}, null, -1)
const _hoisted_4 = ["value", "placeholder"]




export default /*#__PURE__*/_defineComponent({
  __name: 'TableSearch',
  props: {
  modelValue: String,
  label: String,
  placeholder: String,
  styleClass: String,  // Accept class for external styling
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.styleClass)
  }, [
    _createElementVNode("form", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(__props.label), 1),
      _hoisted_3,
      _createElementVNode("input", {
        value: __props.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
        id: "search-field",
        class: "h-full w-80 border border-dark-blue rounded-md py-3 pl-8 pr-0 text-dark-blue placeholder:text-gray-400 sm:text-sm outline-none",
        placeholder: __props.placeholder
      }, null, 40, _hoisted_4)
    ])
  ], 2))
}
}

})